import React from 'react';
import {
    SubheaderRow,
    ViewEventListHeader,
    ViewEventListHeaderSubTitle,
} from './styled';
import { useContainerWidth } from '../../contexts/ContainerWidthContext';
import { Col, Row } from '../../styled';
import { detectMobile } from '../../utils/UiHelper';
import GroupEventItemSubHeader from './GroupEventItemSubHeader';
import { SPORTS } from '../../constants/appConfig';
import {
    MarketButtonsCol,
    OUMarketButtonsCol,
} from '../ViewMainMarkets/styled';
import {
    EventColRight,
    EventMainMarkets,
} from '../../containers/EventListItemContainers/styled';

const GroupEventItemHeader = ({ events, options, title }) => {
    const isFootball = events && events[0].sportId === SPORTS.FOOTBALL;
    const contentWidth = useContainerWidth();
    const isMobile = detectMobile();

    const vinderspilQuantity = events.filter((event) =>
        event.marketList?.[0]?.marketTypeName?.includes('Vinderspil')
    ).length;
    let onlyVinderspilTypes = vinderspilQuantity === events.length;

    const showOUMarkets =
        !isMobile &&
        isFootball &&
        events &&
        !onlyVinderspilTypes &&
        contentWidth > 625;

    if (options['1'] || options['X'] || options['2']) {
        return (
            <ViewEventListHeader $isMobile={isMobile}>
                <ViewEventListHeaderSubTitle
                    $contentWidth={contentWidth}
                    $isMobile={isMobile}
                >
                    <span>{title}</span>
                </ViewEventListHeaderSubTitle>

                <EventMainMarkets
                    $contentWidth={contentWidth}
                    $isMobile={isMobile}
                >
                    <Row $gap={showOUMarkets ? '8px' : '0'}>
                        <MarketButtonsCol
                            $contentWidth={contentWidth}
                            $showOUMarkets={showOUMarkets}
                        >
                            <GroupEventItemSubHeader options={options} />
                        </MarketButtonsCol>
                        {showOUMarkets && (
                            <OUMarketButtonsCol $contentWidth={contentWidth}>
                                <SubheaderRow>
                                    <Col $width={'50%'}>Over mål</Col>
                                    <Col $width={'50%'}>Under mål</Col>
                                </SubheaderRow>
                            </OUMarketButtonsCol>
                        )}
                    </Row>
                </EventMainMarkets>
                {!isMobile && <EventColRight />}
            </ViewEventListHeader>
        );
    } else {
        return (
            <ViewEventListHeader $isMobile={isMobile}>
                <ViewEventListHeaderSubTitle
                    $width={'100%'}
                    $contentWidth={contentWidth}
                    $isMobile={isMobile}
                >
                    <span>{title}</span>
                </ViewEventListHeaderSubTitle>
            </ViewEventListHeader>
        );
    }
};

export default GroupEventItemHeader;
